<template>
          <TabHeader  />    
      <v-card  elevation="16" variant="outlined" class="mx-auto my-8">
          <v-card-item>
         
     <v-card-text>
  <v-container style="text-align: right;color:#0a42da;font-weight: bold;">
    {{nomPatient}}
  </v-container>
    <v-container v-if="creation">
        <v-row>
            <v-col
          cols="6"
          sm="4"
        >
        <v-text-field variant="outlined" v-model="data.datePrise" type="datetime-local" label="Date de prise"></v-text-field>
</v-col>
 
    <v-col
          cols="6"
          sm="4"
        >
    <v-text-field variant="outlined" :rules="[rules.required]" accept="application/pdf"
      clearable v-model="data.nom" type="text" label="Nom"></v-text-field>
</v-col>
<v-col
          cols="6"
          sm="4"
        >
        
  <input type="file"  @change="chargerPhoto($event)" accept="application/pdf"/>

</v-col>
</v-row >
<v-row justify="center">
<v-btn @click="ajouter()" :disabled="isValid()"  color="blue-darken-4"
         class="text-none ms-4 text-white">Valider</v-btn>
<v-btn @click="creation=false"  color="red-darken-4"
         class="text-none ms-4 text-white">Annuler</v-btn>
</v-row>
</v-container>
<v-container v-if="!creation">
    <v-row justify="left">
<v-btn @click="create()"  color="#0a42da"
         class="text-none ms-1 text-white"><v-icon        
        class="me-2"        
      >
      mdi-plus</v-icon>Nouveau document</v-btn>
</v-row>
<v-row >
<v-data-table  style="border-color: #0a42da;border-style: solid;border-width: 0.1px;"
    :items="listData"  
    :headers="headers"  
    no-data-text="Pas de données disponible"
      items-per-page-text="Nombre d'elements par page"
       v-model:sort-by="sortBy"
     >

     <template v-slot:item="row" >
          <tr>
            <td>{{$formatDate(row.item.datePrise)}} </td>
            <td>{{row.item.nom}}</td>        
            <td>
              <embed  :src=getUrl(row.item.file) class="view"/>
              <!-- <img height="50px" :src="'data:image/png;base64, '+row.item.file"/> -->
            </td>
        <td>
      <v-btn @click="data=row.item;creation=true" flat route :to="'/document/'+ getId()+'/'+row.item.id">
      <v-icon
        size="small"
        class="me-2"
        
      >
        mdi-pencil
      </v-icon>
      </v-btn>
      <v-btn  flat @click="deleteItem(row.item)" >
      <v-icon
        size="small"
       
      >
        mdi-delete
      </v-icon>
      </v-btn>
      <v-btn  flat  @click="open(row.item.file)" >
      <v-icon
        size="small"
       
      >
        mdi-download
      </v-icon>Télécharger
      </v-btn>
    </td>   
        </tr>
     </template>
 
    </v-data-table>
</v-row>

      </v-container>
      </v-card-text>
      </v-card-item>
      </v-card>
</template>
<style>
.view{
  width:40;
  height:95}
  embed:hover {
  transform: scale(1.5);
}
</style>
<script>
import http from '../../http.js'
import TabHeader from './TabHeader.vue'

export default {
  components: { TabHeader },
    data: () => ({
      rules: {
        required: value => !!value || 'Le champ est obligatoire',
      },
    creation:false,
    listData:[],
    sortBy:[{key:"datePrise",order:"desc"}],
    headers:[{"title":"Date de prise","key":"datePrise"},{"title":"Nom","key":"nom"},{"title":"Document","key":"file"},{ title: 'Actions', key: 'actions', sortable: false }],
    file: null,
    loading: false,
    nomPatient:null,
    data:{}

    }),
    mounted(){
        this.list();
        this.nomPatient= localStorage.getItem("nomPatient");
    },
    methods:{
    chargerPhoto(e){
        this.file= e.target.files[0];
        this.data.nom=e.target.files[0].name;
    },
    list(){
        http.get('/api/document/'+this.$route.params.id).then(res=>{this.listData=res.data;})
    },
    ajouter(){

      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('name',this.data.nom)
      formData.append('datePrise',this.data.datePrise)
      let path=this.$route.params.id;
     if(this.$route.params.idDocument!=undefined){
        path=this.$route.params.id+"/"+this.$route.params.idDocument;
      }
      http.put('/api/addDocument/'+path, formData)
     .then(() => {   
        this.list()
        this.creation =false
        this.data={}
     })
    }
    ,    getId(){
            return this.$route.params.id;
        },
        create(){
          this.creation=true;
          this.data={};
          this.data.datePrise=new Date().toLocaleString().substring(6,10)+"-"+new Date().toLocaleString().substring(3,5)+'-'+new Date().toLocaleString().substring(0,2)+"T"+new Date().toLocaleString().substring(11,19);
      
    },
   async deleteItem(item){  
  
          if(confirm('Etes vous sur de la suppresion de ce document ?')){
        await    http.delete("/api/document/"+this.getId()+"/"+item.id)
            this.listData.splice(this.listData.indexOf(item), 1);
      }

    },
    isValid(){
     return this.file==undefined ;
    },
    isAdmin(){
            let user =JSON.parse(localStorage.getItem("user"));
           return  user.profil==='admin';
        },
        getUrl(base64){
            const blob= this.base64ToBlob(base64);
             return URL.createObjectURL( blob );
        },
    open(base64){
      window.open(this.getUrl(base64));
     
    },
    base64ToBlob( base64) {
      const binStr = atob( base64 );
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[ i ] = binStr.charCodeAt( i );
      }
      return new Blob( [ arr ], { type: 'application/pdf' } );
  },
}

}
</script>